/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { VApplication } from "../application";
import { SHOWCASE_ASSETS } from "../pages/ClaimAssets/graphql/showcase-assets.query"
import { GraphqlServerModule } from "@vlinder-web/graphql-server-module-react";
import {TEST_DATA } from "./config/assets-test-data"
import {useAsset} from "../pages/ClaimAssets/provider"
import {SOUND ,VIDEO} from "../assets";
import { humanize } from "uno-js";
import {getErrorMessage} from "../utils/error.message";
import { toast } from "react-hot-toast";

const MODULE_NAME = "ClaimAssetsService";
const log: any = LoggerModule.getInstance();

interface IProps{
    imageServer:any
}

const getGraphQLModule = () => {
    const app = VApplication.getInstance();
    return app.getSync("services.GraphqlServerModule") as GraphqlServerModule;
};


export class ClaimAssetsService {
    private static instance: ClaimAssetsService;
    private vapp: VApplication;
    private imageServer;
    private constructor(props: any = {}) {
        this.vapp = VApplication.getInstance();
        this.imageServer = props?.imageServer
      
    }

    
    public static getInstance(props: any = {}): ClaimAssetsService {
        if (!ClaimAssetsService.instance) {
            ClaimAssetsService.instance = new ClaimAssetsService(props);
        }
        return ClaimAssetsService.instance;
    }

  
    async getAssets(size: number, offset: number) {
        const getassetsService = ClaimAssetsService.getInstance();
        const{ id}= useAsset();
        console.log("storeid-showcaseasset",id)
        const graphqlModule = getGraphQLModule();
        const client = graphqlModule.getClient("graphql-gateway");
        try {
            if (client) {
                const res = await client.query({
                    query: SHOWCASE_ASSETS,
                    variables: {
                        size: size,
                        offset: offset,
                        filter: {
                            state:"showcased",
                            store:id
                          }
                    },
                    fetchPolicy:'network-only'
                });
                log.success(MODULE_NAME, "get showcased assets result: ", res);
                // return res?.data?.getAssets;
                if(res){
                    let _data= res?.data?.getAssets?.data;
                                      
                    let results = _data?.map((item:any)=>{
                        const imgUrl = item?.img;
                        const urlFormat = imgUrl?.replace(/^.*\/\/[^\/]+/, '');
                        const imgBBformat = imgUrl?.split('/');
                        const ibbFormat = imgBBformat[imgBBformat.length-3]
                     
                        let _img;
                         if(ibbFormat === "i.ibb.co"){
                            _img = item?.img
                            // _img =`${getassetsService.imageServer}/imgbb${urlFormat}/:/rs=h:500`
                         
                         } 
                         else {
                            _img = item?.img
                            //  _img = `${getassetsService.imageServer}${urlFormat}/:/rs=h:500`
                         }
                          console.log("mui",_img)

                          if(item?.type === "audio"){
                            _img = item?.thumbnail ?? SOUND
                        }
                        if(item?.type === "video"){
                            _img = item?.thumbnail ?? item?.img
                        }
                        return({
                            ...item,
                            img:_img,
                            storeId:id,
                            tag: null,
                            // category: item?.tag?.toLowerCase(),
                            tokenId:item?.serialNo,
                            serialNo:`Rare #/${item?.serialNo}`,
                            subtitle:item?.subtitle?.replace(/<[^>]*>?/gm, '')?.replace(/&nbsp;/g, '')?.replace(/&quot;/g,'"')?.replace(/&.*;/g,''),
                            audioDetail: item?.type === "audio" ? true : false,
                            videoDetail: item?.type === "video" ? true : false,
                            networkType:null,
                        })
                    })
                    return{
                        pagination: {
                            nextOffset: offset + res?.data?.getAssets?.pageSize,
                            totalItems: res?.data?.getAssets?.totalCount
                        },  
                        results
                    }
                }
            }
        } catch (err) {
            getErrorMessage(err);
            return {
                pagination: {
                    nextOffset: 0,
                    totalItems: 0,
                },
                results: [],
            };
        }
    }
}
